import { AppContext } from "@components/features/appContext/AppContext";
import Socials from "@components/features/socials/Socials";
import Button from "@components/primitives/form/Button";
import InputField from "@components/primitives/form/InputField";
import InputTextArea from "@components/primitives/form/InputTextArea";
import Layout from "@components/primitives/layout/Layout";
import Toast from "@components/primitives/toast/Toast";
import usePostContacts from "@hooks/contacts/usePostContacts";
import { appPath } from "@routes/app";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import moment from "moment";
import { useContext, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function ContactPage() {
  const { language } = useContext(AppContext);
  const { mutate, data } = usePostContacts(language);

  const handleFormSubmit = (e: any) => {
    e.preventDefault();

    mutate({
      subject: e.target.subject.value,
      email: e.target.email.value,
      message: e.target.message.value,
      date: moment(new Date()).format("DD-MM-YYYY HH:MM"),
    });

    e.target.reset();
  };

  useEffect(() => {
    if (!data) return;
    Toast("success", translation(language).contact.popup);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Layout>
      <Helmet>
        <title>{createTitle(translation(language).header.contact)}</title>
      </Helmet>
      <div className="h-screen w-full pt-32 pb-20 px-5">
        <h1 className="md:text-3xl text-2xl mb-2">
          {translation(language).contact.title}
        </h1>
        <p className="text-secondary">
          {translation(language).contact.description}
        </p>
        {language === "nl_NL" && (
          <p className="text-secondary">
            Door dit formulier in te vullen, gaat u akkoord met ons
            privacybeleid. Lees{" "}
            <Link to={appPath.privacy} className="underline text-[#4ab6c6]">
              onze privacyverklaring
            </Link>{" "}
            voor meer informatie.
          </p>
        )}

        {language === "en_US" && (
          <p className="text-secondary">
            By submitting this form, you agree to our privacy policy. Please
            read{" "}
            <Link to={appPath.privacy} className="underline text-[#4ab6c6]">
              our privacy statement
            </Link>{" "}
            for more information.
          </p>
        )}

        <div className="w-full flex gap-10">
          <form
            className="w-full mt-10 flex flex-col gap-10"
            onSubmit={handleFormSubmit}
          >
            <InputField
              title={translation(language).contact.form.subject}
              name="subject"
            />
            <InputField
              title={translation(language).contact.form.email}
              name="email"
              type="email"
            />
            <InputTextArea
              title={translation(language).contact.form.message}
              name="message"
            />

            <Button type="submit" theme="blue">
              {translation(language).contact.form.submit}
            </Button>
          </form>
          <div className="w-1/3 h-full mt-11 flex justify-center items-center">
            <Socials />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ContactPage;
